import * as Immutable from "immutable";

import { type Language } from "resourceModels/Language";
import { getResources } from "selectors/resources";
import { type State } from "types";

export const selectLanguages = (state: State) =>
  getResources(state, "language") ?? Immutable.List<Language>();
